import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    hardwares: [],
  }),

  mutations: {
    setHardwares(state, hardwares) {
      Vue.set(state, "hardwares", hardwares);
    },
  },

  actions: {
    //TODO: load, update, create
    createHardware: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/hardwares/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadHardwares: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadHardware: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadPublishedHardwares: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/entity/published").then((response) => {
        context.commit("setHardwares", response.data);
        return response.data;
      });
    },

    loadHardwareHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/hardwares/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedHardwareHistory: (context, hardware) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/history/" + hardware.id, {}).then((response) => {
        return response.data;
      });
    },

    searchHardwareByStationId: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/hardwares/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deleteHardware: (context, hardware) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/hardwares/entity/" + hardware.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          hardware.intents = intents;
          hardware.intentId = response.data.id;
          return hardware;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftHardware: (context, hardware) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/hardwares/draft/" + hardware.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishHardware: (context, hardware) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/publish/" + hardware.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectHardware: (context, hardware) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/reject/" + hardware.intentId).then((response) => {
        helper.recallOrRejectEntity(hardware, "hardware");
        return response.data;
      });
    },

    sendToApprovalHardwares: (context, hardware) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/sendToApproval/" + hardware.intentId).then((response) => {
        if (hardware.intents[0].type === "CREATE_HARDWARE") {
          hardware.intents[0].status = "WAITING_APPROVAL";
        } else if (hardware.intents[0].type === "UPDATE_HARDWARE") {
          hardware.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallHardware: (context, hardware) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/recall/" + hardware.intentId).then((response) => {
        helper.recallOrRejectEntity(hardware, "hardware");
        return response.data;
      });
    },

    cancelHardware: (context, hardware) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/cancel/" + hardware.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getHardwares: (state) => {
      return state.hardwares;
    },
    getPublishedHardwares: (state) => {
      return state.hardwares.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
